import { TemplateCard } from './TemplateCard';
import { ListTemplate } from '@/types/lists';
import { cn } from '@/utils/cn';

interface TemplatesListProps {
  templates: ListTemplate[];
  onClone: (template: ListTemplate) => void;
  onEdit: (template: ListTemplate) => void;
  onDelete: (template: ListTemplate) => void;
  onClick?: (template: ListTemplate) => void;
  className?: string;
}

export function TemplatesList({
  templates,
  onClone,
  onEdit,
  onDelete,
  onClick,
  className
}: TemplatesListProps) {
  if (templates.length === 0) {
    return (
      <div className={cn("text-center py-12", className)}>
        <p className="text-muted-foreground">No templates found matching your criteria.</p>
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col gap-3", className)}>
      {templates.map(template => (
        <TemplateCard
          key={template.id}
          template={template}
          onClone={onClone}
          onEdit={onEdit}
          onDelete={onDelete}
          onClick={onClick}
        />
      ))}
    </div>
  );
}
